import React from 'react';
import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link, useNavigate, useLocation } from 'react-router-dom';
// import FloatingPlayer from './components/FloatingPlayer/FloatingPlayer';
import './App.css';
import MusicPlayer from './components/MusicPlayer/MusicPlayer';
import TemporaryDrawer from './components/TemporaryDrawer/TemporaryDrawer';
import LoginForm from './components/LoginForm/LoginForm';
import RegisterForm from './components/RegisterForm/RegisterForm';
import Privacy from './components/Privacy/Privacy';
import Terms from './components/Terms/Terms';
import NotFound from './components/NotFound/NotFound';

import { AppBar, Toolbar, IconButton, Avatar, Menu, MenuItem, ListItemIcon, Divider, Modal, Box, Typography, Button, Chip } from '@mui/material';
import { MenuRounded, LoginRounded, Logout, AccountCircleRounded, SettingsRounded, ArrowBackIos, ArrowForwardIos, CloseRounded } from '@mui/icons-material';

import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase/firebaseConfig';
import DailyVerse from './components/DailyVerse/DailyVerse';
import fetchMediaModal from './data/fetchs/fetchMediaModal';
import CircularProgress from '@mui/material/CircularProgress';

function App() {
  const [isLogged, setIsLogged] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [station, setStation] = useState('https://embajadoresdelgranrey.online/listen/embajadores_stereo/stream');
  const [volume, setVolume] = useState(100); // Nueva variable de estado para el volumen
  const [user, setUser] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [openModal, setOpenModal] = useState(true);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [modalMedia, setModalMedia] = useState([]);
  const [isImageLoading, setIsImageLoading] = useState(true);

  const audioRef = React.useRef(null);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setIsLogged(true);
        setUser({
          profilePic: user.photoURL,
          name: user.displayName,
          email: user.email,
        });
      } else {
        setIsLogged(false);
        setUser(null);
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    fetchMediaModal()
      .then((media) => {
        setModalMedia(media);
      })
      .catch((error) => console.error("Error fetching modal media:", error));
  }, []);

  useEffect(() => {
    const length = modalMedia.length > 0 ? modalMedia.length : announcements.length;
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % length);
    }, 8000); // Change slide every 8 seconds
    return () => clearInterval(interval);
  }, [modalMedia.length]);

  useEffect(() => {
    if (modalMedia.length > 0) {
      setIsImageLoading(true);
    }
  }, [modalMedia]);

  const toggleDrawer = (newOpen) => () => {
    setDrawerOpen(newOpen);
  };

  const getUserInitial = (name) => {
    return name ? name.charAt(0).toUpperCase() : '';
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    auth.signOut().then(() => {
      setIsLogged(false);
      setUser(null);
      handleMenuClose();
    });
  };

  const handleProfileClick = (event) => {
    if (isLogged) {
      handleMenuOpen(event);
    } else {
      navigate('/login');
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleNextSlide = () => {
    const length = modalMedia.length > 0 ? modalMedia.length : announcements.length;
    setCurrentSlide((prev) => (prev + 1) % length);
  };

  const handlePrevSlide = () => {
    const length = modalMedia.length > 0 ? modalMedia.length : announcements.length;
    setCurrentSlide((prev) => (prev - 1 + length) % length);
  };

  const announcements = [
    // {
    //   type: 'text',
    //   title: '¡Bienvenidos a Embajadores Stereo!',
    //   description: "Estamos emocionados de tenerte aquí mientras damos nuestros primeros pasos en esta nueva aventura. " + 
    //     "En este momento, nos encontramos en fase de prueba, así que agradecemos tu paciencia y comprensión " +
    //     "mientras ajustamos los detalles para ofrecerte la mejor experiencia.\n\n" +
    //     "Tu apoyo y comentarios son invaluable para nosotros. ¡Gracias por ser parte de esta familia y " +
    //     "acompañarnos en la misión de llevar un mensaje de fe, esperanza y amor a través de las ondas!\n\n" +
    //     "¡Disfruta la programación y bendiciones! 🎶🙏",
    //   action: 'Más información',
    // },
    {
      type: 'image',
      src: '/Horarios.png',
    },
    {
      type: 'image',
      src: '/Versiculo.png',
    },
  ];

  // Move handlePlay to App
  const handlePlay = () => {
    if (isPlaying) {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.src = "";
        audioRef.current = null;
      }
      setIsPlaying(false);
    } else {
      setIsLoading(true);
      setIsPlaying(true);
      audioRef.current = new Audio(station);
      audioRef.current.play()
        .then(() => {
          setIsLoading(false);
          handleVolumeChange(null, volume);
        })
        .catch((error) => {
          console.error("Error playing audio:", error);
          setIsPlaying(false);
        });
    }
  };

  // Move handleVolumeChange to App
  const handleVolumeChange = (event, newValue) => {
    setVolume(newValue);
    if (audioRef.current) {
      audioRef.current.volume = newValue / 100;
    }
  };

  return (
    <div className="App">
      {location.pathname === '/' && (
        // Modal para anuncios solo en la ruta "/"
        <Modal
          open={openModal}
          onClose={handleCloseModal}
          aria-labelledby="announcement-modal-title"
          aria-describedby="announcement-modal-description"
        >
          <Box sx={{ 
            position: 'absolute', 
            top: '50%', 
            left: '50%', 
            transform: 'translate(-50%, -50%)', 
            width: '90%', 
            maxWidth: 400, 
            bgcolor: 'background.paper', 
            boxShadow: 24,
            overflow: 'hidden',
            borderRadius: 6
          }}>
            <IconButton onClick={handleCloseModal} sx={{ position: 'absolute', right: 8, top: 8, backgroundColor: 'rgba(0, 0, 0, 0.5)', color: 'white' }}>
              <CloseRounded />
            </IconButton>
            <IconButton onClick={handlePrevSlide} sx={{ display: 'none', position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)' }}>
              <ArrowBackIos />
            </IconButton>
            <IconButton onClick={handleNextSlide} sx={{ display: 'none', position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)' }}>
              <ArrowForwardIos />
            </IconButton>
            {modalMedia.length > 0 && (
              <>
                {isImageLoading && (
                  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    <CircularProgress />
                  </Box>
                )}
                <img 
                  src={modalMedia[currentSlide]} 
                  alt="Anuncio" 
                  style={{ width: '100%', height: '100%', objectFit: 'cover', display: isImageLoading ? 'none' : 'block' }} 
                  onLoad={() => setIsImageLoading(false)}
                />
              </>
            )}
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                handleCloseModal();
                handlePlay();
              }}
              sx={{
                position: 'absolute',
                bottom: 16,
                left: '50%',
                transform: 'translateX(-50%)',
              }}
            >
              {isPlaying ? 'Pausar Radio' : 'Escuchar Radio'}
            </Button>
          </Box>
        </Modal>
      )}
      <AppBar position="static" color="transparent" elevation={0} sx={{ 
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between", // Distribuye los elementos a lo largo del alto
          height: "5vh", // Ocupa todo el alto de la pantalla
       }}>
        <Toolbar sx={{ justifyContent: "space-between", color: "white" }}>
          <IconButton edge="start" onClick={toggleDrawer(true)} sx={{ color: "white" }}>
            <MenuRounded />
          </IconButton>
          {location.pathname !== '/login' && location.pathname !== '/register' && (
            <IconButton edge="end" sx={{ color: "white" }} onClick={handleProfileClick}>
              {isLogged ? (
                user.profilePic ? (
                  <img 
                    src={user.profilePic}
                    style={{ 
                      borderRadius: '50%', 
                      width: '36px', 
                      height: '36px',
                    }}
                  />
                ) : (
                  <Avatar sx={{ bgcolor: 'blue', width: 40, height: 40 }}>
                    {getUserInitial(user.name) || getUserInitial(user.email) || 'U'}
                  </Avatar>
                )
              ) : (
                <LoginRounded />
              )}
            </IconButton>
          )}
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            onClick={handleMenuClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: 'visible',
                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                mt: 1.5,
                '& .MuiAvatar-root': {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                '&:before': {
                  content: '""',
                  display: 'block',
                  position: 'absolute',
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: 'background.paper',
                  transform: 'translateY(-50%) rotate(45deg)',
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
            <MenuItem disabled onClick={() => navigate('/profile')}>
              <ListItemIcon>
                <AccountCircleRounded fontSize="small" />
              </ListItemIcon>
              Mi perfil
            </MenuItem>
            <MenuItem disabled onClick={() => navigate('/settings')}>
              <ListItemIcon>
                <SettingsRounded fontSize="small" />
              </ListItemIcon>
              Configuración
            </MenuItem>
            <Divider />
            <MenuItem onClick={handleLogout}>
              <ListItemIcon>
                <Logout fontSize="small" />
              </ListItemIcon>
              Cerrar sesión
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
      
      <TemporaryDrawer
        open={drawerOpen}
        setOpen={setDrawerOpen}
        toggleDrawer={toggleDrawer}
        station={station}
        isPlaying={isPlaying}
        setStation={setStation}
        isLogged={isLogged}
      />
      <Routes>
        <Route path="/" element={
          <MusicPlayer
              drawerOpen={drawerOpen}
              toggleDrawer={toggleDrawer}
              isPlaying={isPlaying}
              setIsPlaying={setIsPlaying}
              volume={volume}
              setVolume={setVolume}
              audioRef={audioRef}
              handlePlay={handlePlay}
              handleVolumeChange={handleVolumeChange}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              navigate={navigate}
            />
          }
        />
        <Route path="/login" element={<LoginForm toggleDrawer={toggleDrawer} />} />
        <Route path="/register" element={<RegisterForm toggleDrawer={toggleDrawer} />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/versiculodeldia" element={<DailyVerse />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}

export default AppWrapper;
